module.exports = __webpack_public_path__ + "img/elite.508b7832.svg";